//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex';
    import searchFilterCam from '~/components/content/cam/filters/searchFilterCam';
    import filtersCam from '~/mixins/filtersCam.js';

    export default {
      name: 'filtersCam',
      mixins: [filtersCam],
      components: {
        searchFilterCam,
    },
    data() {
        return {
          openedDropdown: '',
      };
  },
  computed: {
    ...mapState({
      camFilter: ({ camStore: { camFilter } }) => camFilter,
  }),
},
methods: {
    toggleDropdown(value) {
      this.openedDropdown = this.openedDropdown === value ? '' : value;
  },
},
};
